export enum RecordTypeEnum {
    Draft = 'Draft',
    Finished = 'Finished'
}
